module.exports = __webpack_public_path__ + "img/media-background-desktop.bd6952f.png";